import { takeLatest, put } from 'redux-saga/effects';
import {
    getTicketListSuccess, getTicketListFail,
    getTicketDetailsSuccess, getTicketDetailsFail,
	updateTicketInList,
} from './ticketState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/support/tickets');
const hrTicketsService = createCrudService('api/v1/support/hr-tickets');
const itTicketsService = createCrudService('api/v1/support/it-tickets');
const psTicketsService = createCrudService('api/v1/support/ps-tickets');
const redirectData = {route:'/console/tickets', mode: 'list', recordId:0 };
const modelName = 'Support Ticket';
const modelId = 'tic_id';

const getTicketService = (ticketType) => {
    switch(ticketType) {
        case 'hr':
            return hrTicketsService;
        case 'it':
            return itTicketsService;
		case 'ps':
            return psTicketsService;
        default:
            return crudService;
    }
};

function* getTicketList(data) {
	const { ticketType, ...filters } = data.payload || {};
    const service = getTicketService(ticketType);
	yield doCrudCall(
		() => service.getList(filters), 
		getTicketListSuccess, 
		getTicketListFail, null, null, LOADING_MSG);
}

function* getTicketDetails(data) {
	const { ticketType, tic_id } = data.payload || {};
    const service = getTicketService(ticketType);
	yield doCrudCall(
		() => service.getDetails(tic_id), 
		getTicketDetailsSuccess, 
		getTicketDetailsFail, null, null, LOADING_MSG);		
}

function* doTicketCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getTicketDetailsSuccess, 
		getTicketDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
        SAVING_MSG);
}

function* doTicketUpdate(data){
    const ticketId = data.payload[modelId];
    const updates = data.payload;
    
    yield put(updateTicketInList({ ticketId, updates }));
    
    yield doCrudCall(
        () => crudService.doUpdate(ticketId, updates), 
        getTicketDetailsSuccess, 
        getTicketDetailsFail,
        null,
        null, 
        UPDATING_MSG
    );    
}

function* doTicketDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getTicketDetailsSuccess, 
		getTicketDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* ticketSaga() {
  yield takeLatest('ticket/getTicketList', getTicketList);
  yield takeLatest('ticket/getTicketDetails', getTicketDetails);
  yield takeLatest('ticket/doTicketCreate', doTicketCreate);
  yield takeLatest('ticket/doTicketUpdate', doTicketUpdate);
  yield takeLatest('ticket/doTicketDelete', doTicketDelete); 
}

export default ticketSaga;
